import React from 'react';
import './SearchFeatureContainerMenu.css';

const SearchFeatureContainerMenu = ({ selectedFeature, handleFeatureChange}) => {
  return (
    <div className="feature-selector" style={{ marginBottom: 24 }}>
      <button
        className={selectedFeature === 'search' ? 'feature-btn selected' : 'feature-btn'}
        onClick={() => handleFeatureChange('search')}
      >
        KI-Suche
      </button>
      <button
        className={selectedFeature === 'conversational' ? 'feature-btn selected' : 'feature-btn'}
        onClick={() => handleFeatureChange('conversational')}
      >
        Dialogsuche
      </button>
      <button
        className={selectedFeature === 'popular' ? 'feature-btn selected' : 'feature-btn'}
        onClick={() => handleFeatureChange('popular')}
      >
        Favoritensuche
      </button>
    </div>
  );
};

export default SearchFeatureContainerMenu;